var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9609 0.306253C10.9226 0.215252 10.8583 0.13761 10.776 0.0831104C10.6937 0.0286112 10.5971 -0.000306351 10.4984 2.44755e-06H0.498389C0.399676 -0.000306351 0.303081 0.0286112 0.220776 0.0831104C0.138471 0.13761 0.0741397 0.215252 0.0358889 0.306253C-0.000133816 0.398608 -0.0092723 0.499275 0.00953055 0.596607C0.0283334 0.69394 0.0743092 0.783959 0.142139 0.856252L5.14214 5.85625C5.23771 5.94866 5.36545 6.00032 5.49839 6.00032C5.63133 6.00032 5.75907 5.94866 5.85464 5.85625L10.8546 0.856252C10.9225 0.783959 10.9684 0.69394 10.9872 0.596607C11.0061 0.499275 10.9969 0.398608 10.9609 0.306253Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandOpen);
export default __webpack_public_path__ + "static/media/expand-open.32bb479aca7645c92b4abd38f8e48f20.svg";
export { ForwardRef as ReactComponent };